
import { CertificateLogo as CertLogo } from "../brand/LogoExports";

export function CertificateLogo() {
  return (
    <div className="flex flex-col items-center justify-center">
      <CertLogo />
    </div>
  );
}
